import Box from '~/common/components/Box';

import Snackbar from './Snackbar';
import { useSnackbarStore } from './snackbarStore';

// Must match anchor-name on the ActionBar; falls back to the viewport center when it isn't rendered.
const ACTION_BAR_CENTER = 'anchor(--action-bar center, 50%)';

/**
 * This container is used to create a provider-like context for the Snackbar component
 * making use of this avoids mounting and unmounting issues with the Snackbar component that leads to it flashing multiple times
 * as well as allowing the use of the useSnackbar hook throughout the app and creating a single source of truth for snackbars.
 * Snackbars are centered over the viewport unless one opts in with anchorToActionBar.
 */
const SnackbarContainer = () => {
  const { snackBars, closeSnackbar } = useSnackbarStore();

  if (!snackBars.length) {
    return null;
  }

  const anchorToActionBar = snackBars.some((s) => s.anchorToActionBar);

  return (
    <Box
      sx={{
        position: 'fixed',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        width: 'max-content',
        bottom: 'calc(2.5rem + 24px)',
        left: anchorToActionBar ? ACTION_BAR_CENTER : '50%',
        transform: 'translateX(-50%)',
        gap: 1,
        zIndex: 9999999,
      }}
    >
      {snackBars.map(({ id, message, severity, duration }) => (
        <Snackbar
          key={id}
          message={message}
          severity={severity}
          duration={duration ?? 6000}
          onClose={() => closeSnackbar(id)}
        />
      ))}
    </Box>
  );
};

export default SnackbarContainer;
